/* import __COLOCATED_TEMPLATE__ from './active-operation.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();